import { register } from "@rill/loader";

// Short ttl on purpose (like sendingSettings): an automation changes with every toggle and save,
// and with the engine too (how many people are inside, the sends of the last 30 days)
register(
  { name: "automationsList", ttl: "2 seconds" },
  async ({ api }, product) => {
    const res = await api("automations", { query: { product } });
    if (!res.ok) return null;
    return res.json();
  }
);

register(
  { name: "automationDetail", ttl: "2 seconds" },
  async ({ api }, id) => {
    const res = await api(`automations/${id}`);
    if (!res.ok) return null;
    return res.json();
  }
);

// The definitions of the triggers do not change while the app runs
register(
  { name: "automationTriggers", ttl: "2 hours" },
  async ({ api }, product) => {
    const res = await api("automation-triggers", {
      query: product ? { product } : {},
    });
    if (!res.ok) return null;
    return res.json();
  }
);

register(
  { name: "automationFilterOptions", ttl: "10 minutes" },
  async ({ api }) => {
    const res = await api("automation-filter-options");
    if (!res.ok) return null;
    return res.json();
  }
);

// What turning an automation on would do for the people who already qualify
register(
  { name: "automationBackfill", ttl: "2 seconds" },
  async ({ api }, id) => {
    const res = await api(`automations/${id}/backfill`);
    if (!res.ok) return null;
    return res.json();
  }
);

// The starter automations for a product: MSB's (fixed) and the ones the account saves (they change)
register(
  { name: "automationTemplates", ttl: "2 seconds" },
  async ({ api }, product) => {
    const res = await api("automation-templates", { query: { product } });
    if (!res.ok) return null;
    return res.json();
  }
);

// The activity log of an automation (`params`: status, search, sort, dir, page) and the journey of one person
register(
  { name: "automationActivity", ttl: "2 seconds" },
  async ({ api }, { id, ...query }) => {
    const res = await api(`automations/${id}/activity`, { query });
    if (!res.ok) return null;
    return res.json();
  }
);

register(
  { name: "automationJourney", ttl: "2 seconds" },
  async ({ api }, { id, enrollmentId }) => {
    const res = await api(`automations/${id}/activity/${enrollmentId}`);
    if (!res.ok) return null;
    return res.json();
  }
);
